import { a11yScript } from "../scripts/a11y/a11y-info"

interface ICallScriptMockData{
    script:string
    result:any
    fn?:(script:string)=>any
}
export const callScriptMockDataMap:{[key:string]:ICallScriptMockData} = {
    // [a11yScript.hasPermissionScript]:{
    //     script:a11yScript.hasPermissionScript,
    //     result:true,
    //     fn:a11yScript.hasPermission
    // }
}